import { Typography } from '@material-ui/core'
import FlightLandIcon from '@material-ui/icons/FlightLand'

import { getTranslate } from '../../localization'
import useStyles from './styles/SearchWidgetArrivalDate.styles'

export type DATE = {
  data: { year: string; month: string; day: string }
  selectingStartDate: boolean
}
const SearchWidgetArrivalDate: React.FC<DATE> = ({
  data,
  selectingStartDate
}) => {
  const classes = useStyles()
  const { year, month, day } = data

  return (
    <div className={classes.root}>
      <div className={classes.labelHeader}>
        <FlightLandIcon
          className={[
            classes.icon,
            selectingStartDate ? classes.selectedIcon : ''
          ].join(' ')}
        />
        <Typography
          variant="h4"
          className={[
            classes.title,
            selectingStartDate ? classes.selectedIcon : ''
          ].join(' ')}>
          {getTranslate('Arrival')}
        </Typography>
      </div>
      <div className={classes.dateContainer}>
        <div className={classes.dayContainer}>
          <Typography variant="h5" color="primary" className={classes.number}>
            {day}
          </Typography>
        </div>
        <div className={classes.monthContainer}>
          <Typography variant="h5" className={classes.title2}>
            {month} {year}
          </Typography>
        </div>
      </div>
    </div>
  )
}
export default SearchWidgetArrivalDate
